import { AlertTriangle } from "lucide-react";

/**
 * Surfaces a client's "Important Remark" prominently — used across every
 * module that displays client info so the note set on creation/edit reaches
 * everyone (Sales, Documentation, Dispatch, Accounts, etc.).
 */
export default function ClientImportantRemark({ remark, className = "" }) {
  if (!remark || !String(remark).trim()) return null;
  return (
    <div
      className={`flex items-start gap-2 border-2 border-amber-300 bg-amber-50/80 dark:bg-amber-900/20 rounded-md p-2.5 ${className}`}
      data-testid="client-important-remark"
    >
      <AlertTriangle size={14} className="text-amber-600 mt-[2px] flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-[10px] uppercase tracking-wider font-semibold text-amber-800 dark:text-amber-300">
          Important Remark
        </div>
        <div className="text-[12px] text-slate-800 dark:text-slate-100 whitespace-pre-wrap break-words mt-0.5">
          {remark}
        </div>
      </div>
    </div>
  );
}
